import { regex, requiredString, requiredWerteListeObjekt, VALIDATION_MESSAGE_TELEFON, validEmail } from "../utils/Validator";
import { REGEX_TELEFONNUMMER } from "../consts/regex";

export const createPersonSchema = () => {
    return {
        anrede: requiredWerteListeObjekt().error((tmpErrors) => {
            tmpErrors[0].path = ["anrede"];
            return tmpErrors[0];
        }),
        name: requiredString("Name").error((tmpErrors) => {
            tmpErrors[0].path = ["name"];
            return tmpErrors[0];
        }),
        vorname: requiredString("Vorname").error((tmpErrors) => {
            tmpErrors[0].path = ["vorname"];
            return tmpErrors[0];
        }),
        email: validEmail("E-Mail").error((tmpErrors) => {
            tmpErrors[0].path = ["email"];
            return tmpErrors[0];
        }),
        telefon: regex(REGEX_TELEFONNUMMER, true, VALIDATION_MESSAGE_TELEFON).error((tmpErrors) => {
            tmpErrors[0].path = ["telefon"];
            return tmpErrors[0];
        }),
        mobil: regex(REGEX_TELEFONNUMMER, false, VALIDATION_MESSAGE_TELEFON).error((tmpErrors) => {
            tmpErrors[0].path = ["mobil"];
            return tmpErrors[0];
        }),
    };
};
